<template>
  <div
    class="points-page"
    :class="{ 'points-page--subview': view !== 'main' }"
    :style="
      view !== 'main' && viewportHeight
        ? { height: viewportHeight + 'px' }
        : null
    "
  >
    <!-- 主视图：我的积分 -->
    <div v-show="view === 'main'">
      <!-- 顶部渐变+金币背景区：余额直接压在背景上（返回/标题由宿主原生导航提供） -->
      <section class="head">
        <div class="balance-wrap">
          <div class="balance-row">
            <img class="balance-icon" :src="icon('pointsIcon.png')" alt="" />
            <span class="balance-label">积分余额</span>
            <span class="balance-rules" @click="showRules = true"
              >积分兑换规则</span
            >
          </div>
          <div class="balance-num">{{ balance === null ? "--" : balance }}</div>
          <div class="balance-detail" @click="view = 'detail'">
            积分明细&gt;&gt;
          </div>
          <div class="sign-btn" :class="{ signed: signed }" @click="doSign">
            <img
              v-if="!signed"
              class="sign-icon"
              :src="icon('checkIcon.png')"
              alt=""
            />
            <span>{{
              signing
                ? "签到中"
                : signed === null
                ? "加载中"
                : signed
                ? "已签到"
                : "签到"
            }}</span>
          </div>
        </div>
      </section>

      <!-- 做任务领积分 -->
      <div v-if="mainError" class="list-state" @click="loadAll">
        加载失败，点击重试
      </div>
      <section class="task-card">
        <div class="task-title">
          做任务领积分
          <img
            class="title-bar"
            src="../../../static/pointsTestIcon1.png"
            alt=""
          />
        </div>
        <div class="task-row" v-for="(task, i) in tasks" :key="i">
          <img class="task-icon" :src="icon(task.icon)" alt="" />
          <div class="task-info">
            <div class="task-name">{{ task.title }}</div>
            <div class="task-points">
              +{{ task.points }}
              <span v-if="task.note" class="task-note">{{ task.note }}</span>
            </div>
          </div>
          <span v-if="task.status === 'done'" class="task-pill done"
            >已完成</span
          >
          <span v-else class="task-go" @click="onTask(task)">去完成</span>
        </div>
      </section>

      <!-- 积分商品兑换 -->
      <section class="goods-section">
        <div class="goods-head">
          <div class="goods-title">
            积分商品兑换
            <img
              class="title-bar"
              src="../../../static/pointsTestIcon2.png"
              alt=""
            />
          </div>
          <div class="goods-record" @click="view = 'record'">
            积分兑换记录&gt;&gt;
          </div>
        </div>
        <div class="goods-grid">
          <div class="goods-card" v-for="(goods, i) in products" :key="i">
            <div class="goods-img">
              <img v-if="goods.img" :src="goods.img" alt="" />
            </div>
            <div class="goods-name-row">
              <span class="goods-name">{{ goods.name }}</span>
              <span class="goods-fav" @click="toggleLike(goods)">
                <svg viewBox="0 0 24 24">
                  <path
                    d="M12 20s-7-4.6-9.2-8.8C1.2 8 3 4.8 6.4 4.8c2 0 3.6 1.1 4.6 2.7 1-1.6 2.6-2.7 4.6-2.7 3.4 0 5.2 3.2 3.6 6.4C17 15.4 12 20 12 20Z"
                    :fill="goods.fav ? '#ff7a1a' : 'none'"
                    :stroke="goods.fav ? '#ff7a1a' : '#b9bfc9'"
                    stroke-width="1.8"
                  />
                </svg>
              </span>
            </div>
            <div class="goods-buy-row">
              <span class="goods-points">{{ goods.points }}积分</span>
              <span class="goods-exchange" @click="openExchange(goods)"
                >兑换</span
              >
            </div>
          </div>
        </div>
        <div class="list-state" @click="loadPage('goods')">
          {{ pageMessage("goods") }}
        </div>
      </section>
    </div>

    <!-- 积分明细视图 -->
    <div v-show="view === 'detail'" class="detail-view">
      <div class="detail-tabs">
        <span
          class="detail-tab"
          :class="{ active: detailTab === 'in' }"
          @click="detailTab = 'in'"
          >仅获得</span
        >
        <span
          class="detail-tab"
          :class="{ active: detailTab === 'out' }"
          @click="detailTab = 'out'"
          >消耗/过期</span
        >
      </div>
      <div ref="detailList" class="detail-list">
        <div v-for="(group, gi) in currentDetail" :key="gi">
          <div class="detail-month">{{ group.month }}</div>
          <div class="detail-row" v-for="(row, ri) in group.rows" :key="ri">
            <div class="detail-left">
              <div class="detail-label">{{ row.label }}</div>
              <div class="detail-time">{{ row.time }}</div>
            </div>
            <div class="detail-amount" :class="{ plus: row.amount > 0 }">
              {{ row.amount > 0 ? "+" + row.amount : row.amount }}
            </div>
          </div>
        </div>
        <div
          class="list-state"
          :class="{ empty: !pages[detailTab].rows.length }"
          @click="loadPage(detailTab)"
        >
          {{ pageMessage(detailTab) }}
        </div>
      </div>
    </div>

    <!-- 商品兑换记录视图 -->
    <div v-show="view === 'record'" class="detail-view">
      <div ref="recordList" class="detail-list">
        <div v-for="(group, gi) in exchangeRecords" :key="gi">
          <div class="detail-month">{{ group.month }}</div>
          <div class="detail-row" v-for="(row, ri) in group.rows" :key="ri">
            <div class="detail-left">
              <div class="detail-label">{{ row.label }}</div>
              <div class="detail-time">{{ row.time }}</div>
            </div>
            <div class="detail-amount">{{ row.amount }}</div>
          </div>
        </div>
        <div
          class="list-state"
          :class="{ empty: !pages.record.rows.length }"
          @click="loadPage('record')"
        >
          {{ pageMessage("record") }}
        </div>
      </div>
    </div>

    <!-- 明细/兑换记录视图底部返回按钮 -->
    <div class="detail-footer" v-if="view !== 'main'">
      <div class="detail-back" @click="view = 'main'">返回</div>
    </div>

    <!-- 积分兑换规则弹窗 -->
    <div class="mask" v-if="showRules" @click.self="showRules = false">
      <div class="rules-box">
        <div class="rules-bell">
          <svg viewBox="0 0 24 24">
            <path
              fill="#fff"
              d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Zm8-5v-1l-1.5-1.5V10a6.5 6.5 0 0 0-5-6.32V3a1.5 1.5 0 0 0-3 0v.68a6.5 6.5 0 0 0-5 6.32v4.5L4 16v1Z"
            />
          </svg>
        </div>
        <span class="box-close" @click="showRules = false">
          <svg viewBox="0 0 24 24">
            <path
              d="M6 6l12 12M18 6L6 18"
              stroke="#9aa1ad"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <div class="rules-title">积分兑换规则</div>
        <div class="rules-body">
          <p>积分仅可在平台内使用，不可折现、不可转让、不可提现</p>
          <p>①积分兑换后不可撤销和更改</p>
          <p>②积分积攒到1000可进行商品兑换</p>
          <p>③每次领取的积分有效期为180天，180天后当天领取的积分清零；</p>
        </div>
      </div>
    </div>

    <!-- 商品兑换信息弹窗 -->
    <div class="mask" v-if="showExchange" @click.self="showExchange = false">
      <div class="exchange-box">
        <div class="exchange-head">
          <span class="exchange-title">商品兑换</span>
          <span class="box-close" @click="showExchange = false">
            <svg viewBox="0 0 24 24">
              <path
                d="M6 6l12 12M18 6L6 18"
                stroke="#9aa1ad"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </span>
        </div>
        <div class="exchange-sub">
          {{
            exchangeProduct && exchangeProduct.goodsType === 1
              ? "确认使用积分兑换该商品"
              : "请输入兑换信息，便于商品邮寄"
          }}
        </div>
        <template v-if="exchangeProduct && exchangeProduct.goodsType === 2">
          <div class="form-item">
            <div class="form-label">姓名</div>
            <input
              v-model="exchangeForm.name"
              type="text"
              maxlength="50"
              placeholder="请输入收货人姓名"
            />
          </div>
          <div class="form-item">
            <div class="form-label">电话</div>
            <input
              v-model="exchangeForm.phone"
              type="tel"
              maxlength="11"
              placeholder="请输入收货人联系电话"
            />
          </div>
          <div class="form-item">
            <div class="form-label">地址</div>
            <input
              v-model="exchangeForm.address"
              type="text"
              maxlength="100"
              placeholder="请输入收货人地址信息"
            />
          </div>
        </template>
        <div class="exchange-submit" @click="submitExchange">
          {{ exchanging ? "兑换中" : receiverLoading ? "加载中" : "确认兑换" }}
        </div>
      </div>
    </div>

    <!-- 小程序兑换引导下载 App 弹窗 -->
    <div class="mask" v-if="showAppTip" @click.self="showAppTip = false">
      <div class="app-tip-box">
        <img
          class="app-tip-img"
          :src="icon('guidance.png')"
          alt=""
          @click="showAppTip = false"
        />
        <span class="app-tip-close" @click="showAppTip = false">
          <svg viewBox="0 0 24 24">
            <path
              d="M6 6l12 12M18 6L6 18"
              stroke="#fff"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { pointsRequest, groupPointsRows } from "../../api/points";
// 积分页图标 OSS 目录（图标已按名称上传 OSS）
const OSS_BASE =
  "https://baoanlailou-online.oss-cn-beijing.aliyuncs.com/miniapp/"; // TODO: 与上传目录核对

export default {
  name: "points",
  data() {
    return {
      // main / detail 两个内部视图
      view: "main",
      viewportHeight: 0,
      showRules: false,
      showExchange: false,
      showAppTip: false,
      signed: null,
      signing: false,
      exchanging: false,
      balanceWarnShowing: false,
      receiverLoading: false,
      refreshing: false,
      tokenReady: false,
      mainError: false,
      balance: null,
      // 用户信息（bodyguard/center 接口返回，进入页面后按 TOKEN 拉取）
      userInfo: null,
      detailTab: "in",
      tasks: [],
      products: [],
      rules: [],
      taskStatuses: [],
      exchangeRecords: [],
      detailIn: [],
      detailOut: [],
      pages: {
        goods: { page: 0, more: true, loading: false, error: false, rows: [] },
        in: { page: 0, more: true, loading: false, error: false, rows: [] },
        out: { page: 0, more: true, loading: false, error: false, rows: [] },
        record: { page: 0, more: true, loading: false, error: false, rows: [] }
      },
      exchangeForm: { name: "", phone: "", address: "" },
      exchangeProduct: null,
      tiaoshi: false // 是否本地浏览器调试
    };
  },
  computed: {
    currentDetail() {
      return this.detailTab === "in" ? this.detailIn : this.detailOut;
    }
  },
  watch: {
    // 内部视图切换时同步标题，原生栏跟着变（明细/记录/主视图）
    view() {
      if (this.view !== "main") {
        this.lockPageScroll();
        this.syncViewportHeight();
      }
      this.$nextTick(() => {
        if (this.view === "main") this.unlockPageScroll();
        else this.resetListScroll();
      });
      this.syncTitle();
      if (this.view === "detail") this.loadPage(this.detailTab, true);
      if (this.view === "record") this.loadPage("record", true);
    },
    detailTab() {
      this.$nextTick(() => this.resetListScroll());
      if (this.view === "detail" && !this.pages[this.detailTab].page)
        this.loadPage(this.detailTab);
    }
  },
  mounted() {
    // 与 win.vue/veteran.vue 一致的进入逻辑：
    // 小程序 web-view 由小程序端拼 token 到 URL；App 端走原生桥 getUserInfo 回调
    this._previousSetUserInfo = window.setUserInfo;
    this._previousRefreshPoints = window.refreshPoints;
    this._setUserInfo = val => {
      try {
        const obj = typeof val === "string" ? JSON.parse(val) : val;
        const token = obj.loginUserVO.accessToken;
        if (!token) throw new Error("用户信息缺少 accessToken");
        localStorage.setItem("TOKEN", token);
        this.tokenReady = true;
        this.loadAll();
      } catch (error) {
        this.mainError = true;
        this.showError(error);
      }
    };
    window.setUserInfo = this._setUserInfo;
    this._refreshPoints = () => this.loadAll();
    window.refreshPoints = this._refreshPoints;
    // 本地调试开关：tiaoshi 为 true 时跳过小程序/App 入口流程，直接用本地缓存的 TOKEN 走后续流程
    if (this.tiaoshi) {
      const cachedToken = localStorage.getItem("TOKEN");
      if (cachedToken) {
        this.tokenReady = true;
        this.loadAll();
      } else {
        console.warn(
          "tiaoshi 调试模式：本地缓存无 TOKEN，请先写入 localStorage.setItem('TOKEN', ...)"
        );
      }
    } else if (this.$route.query.token) {
      localStorage.setItem("TOKEN", this.$route.query.token);
      this.tokenReady = true;
      this.loadAll();
    } else {
      this.requestUserInfo();
    }
    // 禁用 #app/body 的全局 transform（scale(1)）：它使 fixed 弹窗相对 #app/body（随内容高）解析，弹窗无法贴屏幕居中
    const appEl = document.getElementById("app");
    if (appEl) appEl.style.transform = "none";
    document.body.style.transform = "none";
    // 微信 webview 首帧合成宽度偶现陈旧致右侧白条（切换内部视图即全页重绘自愈）：
    // 进入后多时机强制全页重绘 + resize/pageshow/回前台时自愈
    this.fixWebviewGap();
    this._gapTimers = [100, 400, 1000, 2000].map(t =>
      setTimeout(() => this.fixWebviewGap(), t)
    );
    this.syncViewportHeight();
    this._onResize = () => {
      this.syncViewportHeight();
      this.fixWebviewGap();
    };
    this._onShow = () => {
      this.syncViewportHeight();
      this.fixWebviewGap();
      if (!document.hidden) this.loadAll();
    };
    window.addEventListener("resize", this._onResize);
    if (window.visualViewport)
      window.visualViewport.addEventListener("resize", this._onResize);
    window.addEventListener("pageshow", this._onShow);
    document.addEventListener("visibilitychange", this._onShow);
    this.syncTitle();
  },
  beforeDestroy() {
    if (window.setUserInfo === this._setUserInfo)
      window.setUserInfo = this._previousSetUserInfo;
    if (window.refreshPoints === this._refreshPoints)
      window.refreshPoints = this._previousRefreshPoints;
    (this._gapTimers || []).forEach(clearTimeout);
    window.removeEventListener("resize", this._onResize);
    if (window.visualViewport)
      window.visualViewport.removeEventListener("resize", this._onResize);
    window.removeEventListener("pageshow", this._onShow);
    document.removeEventListener("visibilitychange", this._onShow);
    this.unlockPageScroll(false);
    // 还原全局 transform 内联值，交还样式表规则
    const appEl = document.getElementById("app");
    if (appEl) appEl.style.transform = "";
    document.body.style.transform = "";
  },
  methods: {
    // 使用实际可见高度，兼容移动端地址栏、横竖屏及 WebView 视口变化。
    syncViewportHeight() {
      this.viewportHeight =
        (window.visualViewport && window.visualViewport.height) ||
        window.innerHeight ||
        document.documentElement.clientHeight;
    },
    // 子视图独占一屏，锁住外层滚动；保存主页位置，返回后再恢复。
    lockPageScroll() {
      if (this._scrollLock) return;
      this._mainScrollTop = window.pageYOffset || 0;
      this._scrollLock = [
        { el: document.documentElement, styles: { overflow: "hidden" } },
        {
          el: document.body,
          styles: {
            position: "fixed",
            top: "0",
            left: "0",
            right: "0",
            overflow: "hidden"
          }
        }
      ].map(({ el, styles }) => {
        const previous = {};
        Object.keys(styles).forEach(key => {
          previous[key] = el.style[key];
          el.style[key] = styles[key];
        });
        return { el, styles: previous };
      });
      window.scrollTo(0, 0);
    },
    unlockPageScroll(restorePosition = true) {
      if (!this._scrollLock) return;
      this._scrollLock.forEach(({ el, styles }) => {
        Object.keys(styles).forEach(key => {
          el.style[key] = styles[key];
        });
      });
      this._scrollLock = null;
      if (restorePosition) window.scrollTo(0, this._mainScrollTop || 0);
    },
    resetListScroll() {
      const list = this.$refs[this.view + "List"];
      if (list) list.scrollTop = 0;
    },
    // 切换 transform 强制 body 与页面根节点重新布局/合成，消除陈旧绘制宽度导致的右侧白条
    fixWebviewGap() {
      [document.body, this.$el].forEach(el => {
        if (!el) return;
        el.style.transform = "translateZ(0)";
        void el.offsetWidth;
        // body 恢复为本页基线（已禁用全局 transform），页面根节点恢复为内联空值
        el.style.transform = el === document.body ? "none" : "";
      });
      // 钳制水平滚动偏移，避免内容左移露出右侧空白
      window.scrollTo(0, window.pageYOffset);
    },
    icon(name) {
      return OSS_BASE + name;
    },
    // 原生栏标题跟随内部视图：web-view 会把 document.title 反射进小程序原生导航栏
    syncTitle() {
      const map = {
        main: "我的积分",
        detail: "积分明细",
        record: "积分兑换记录"
      };
      document.title = map[this.view] || "我的积分";
      // iOS WKWebView 的 title 只在导航提交时刷新，document.title 赋值不生效：
      // 借隐藏 iframe 的一次子导航强制重读标题（安卓/web-view 直接生效，无副作用）
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.setAttribute("src", "about:blank");
        iframe.addEventListener("load", () => {
          setTimeout(() => {
            iframe.remove();
          }, 0);
        });
        document.body.appendChild(iframe);
      }
    },
    // 加载积分数据（余额/任务/商品/明细）
    // 接口一律走全局 $axios：请求拦截器自动带 x-sec-m-token（取自 localStorage.TOKEN），无需手动传头
    showError(error) {
      if (error && error.respCode !== undefined) return;
      this.$message({
        message: (error && error.message) || "请求失败，请重试",
        type: "warning"
      });
    },
    requireLogin() {
      if (this.tokenReady && localStorage.getItem("TOKEN")) return true;
      this.$message({ message: "请先登录", type: "warning" });
      this.requestUserInfo();
      return false;
    },
    loadPublic() {
      if (!this.tokenReady || !localStorage.getItem("TOKEN")) return;
      this.loadPage("goods", true);
      return pointsRequest("ruleList")
        .then(data => {
          this.rules = data || [];
          this.updateTasks();
        })
        .catch(error => {
          this.mainError = true;
          this.showError(error);
        });
    },
    // 进入页面获取用户信息：小程序（URL token）与 App（原生桥回调 token）两条链路
    // 拿到 TOKEN 后统一请求 bodyguard/center，存入组件 data.userInfo；token 由拦截器自动携带
    loadUserCenter() {
      return this.$axios
        .get("/mapi/api/bodyguard/center")
        .then(({ data }) => {
          this.userInfo = data || null;
          console.log("获取用户信息成功", data);
          return data;
        })
        .catch(error => {
          // 辅助数据：失败不阻塞页面主数据（业务错误拦截器已统一提示）
          console.warn("获取用户信息失败", error);
          return null;
        });
    },
    async loadAll() {
      if (this.refreshing) return;
      if (!this.tokenReady || !localStorage.getItem("TOKEN")) return;
      this.refreshing = true;
      this.mainError = false;
      const jobs = [
        this.loadPublic(),
        this.loadUserCenter(),
        pointsRequest("myPoints").then(data => {
          this.balance = data.availablePoints;
        }),
        pointsRequest("taskStatus").then(data => {
          this.taskStatuses = data || [];
          // 签到可点击性以 taskStatus 的签到任务（type=1）为准：未完成→可点击签到，已完成→不可再点
          const signTask = this.taskStatuses.find(t => t.taskType === 1);
          if (signTask) this.signed = !!signTask.finished;
          this.updateTasks();
        })
      ];
      if (this.view === "detail")
        jobs.push(this.loadPage(this.detailTab, true));
      if (this.view === "record") jobs.push(this.loadPage("record", true));
      await Promise.all(
        jobs.map(job =>
          job.catch(error => {
            this.mainError = true;
            this.showError(error);
          })
        )
      );
      this.refreshing = false;
    },
    updateTasks() {
      const codes = [
        "",
        "SIGN_IN",
        "BROWSE_JOB",
        "RESUME",
        "REGISTER",
        "COMMUNICATE",
        "SHARE"
      ];
      const icons = [
        "",
        "points2.png",
        "points3.png",
        "points4.png",
        "points1.png",
        "points5.png",
        "points6.png"
      ];
      // 任务列表以 taskStatus（后端下发的生效任务+用户状态）为准；
      // 未登录无 taskStatus 数据时回退 ruleList 规则列表
      const sources = this.taskStatuses.length
        ? this.taskStatuses.map(state => ({
            type: state.taskType,
            state,
            rule: this.rules.find(
              r => codes.indexOf(r.ruleCode) === state.taskType
            )
          }))
        : this.rules
            .map(rule => ({
              type: codes.indexOf(rule.ruleCode),
              state: null,
              rule
            }))
            .filter(item => item.type > 0);
      this.tasks = sources.map(({ type, state, rule }) => {
        const max =
          state && state.dailyMaxPoints != null
            ? state.dailyMaxPoints
            : rule && rule.dailyMaxPoints != null
            ? rule.dailyMaxPoints
            : null;
        // 签到（type=1）状态与顶部签到按钮保持一致，由 taskStatus 的签到任务同步
        const finished =
          type === 1 && this.signed !== null
            ? this.signed
            : !!(state && state.finished);
        let note = "";
        if (type === 3 || type === 4) note = "仅首次有效";
        else if (max != null) note = "每日上限" + max;
        return {
          type,
          ruleCode:
            (state && state.ruleCode) || (rule && rule.ruleCode) || codes[type],
          icon: icons[type] || "pointsIcon.png",
          title: (state && state.taskName) || (rule && rule.ruleName) || "",
          points:
            state && state.awardPoints != null
              ? state.awardPoints
              : rule
              ? rule.awardPoints
              : 0,
          note,
          status: finished ? "done" : "todo"
        };
      });
    },
    pageMessage(key) {
      const page = this.pages[key];
      if (page.loading) return "加载中…";
      if (page.error) return "加载失败，点击重试";
      if (!page.rows.length) return "暂无数据";
      return page.more ? "加载更多" : "已全部加载";
    },
    async loadPage(key, reset = false) {
      if (!this.tokenReady || !localStorage.getItem("TOKEN")) return;
      const state = this.pages[key];
      if (state.loading || (!reset && !state.more)) return;
      if (key !== "goods" && !this.requireLogin()) return;
      state.loading = true;
      state.error = false;
      const page = reset ? 1 : state.page + 1;
      const endpoint =
        key === "goods"
          ? "goodsPage"
          : key === "record"
          ? "exchangeRecordPage"
          : "flowPage";
      const params = { page, pageSize: 20 };
      if (key === "in" || key === "out")
        params.flowTypes = key === "in" ? [1] : [2, 3];
      try {
        const data = await pointsRequest(endpoint, params);
        const rows = data.records || [];
        state.rows = reset ? rows : state.rows.concat(rows);
        state.page = page;
        state.more = page < Number(data.pages);
        if (key === "goods") {
          this.products = state.rows.map(item => ({
            id: item.id,
            goodsType: item.goodsType,
            name: item.goodsName,
            points: item.pointsPrice,
            img: item.coverUrl,
            fav: item.liked,
            liking: false
          }));
        } else {
          const groups = groupPointsRows(
            state.rows.map(item => ({
              label: key === "record" ? item.goodsName : item.name,
              time: key === "record" ? item.exchangeTime : item.time,
              amount: key === "record" ? item.pointsCost : item.points
            }))
          );
          if (key === "record") this.exchangeRecords = groups;
          else if (key === "in") this.detailIn = groups;
          else this.detailOut = groups;
        }
      } catch (error) {
        state.error = true;
        this.showError(error);
      } finally {
        state.loading = false;
      }
    },
    async toggleLike(goods) {
      if (goods.liking || !this.requireLogin()) return;
      goods.liking = true;
      try {
        const data = await pointsRequest("like", {
          goodsId: goods.id,
          action: goods.fav ? 2 : 1
        });
        if (!data.result) throw new Error("操作失败，请重试");
        goods.fav = !goods.fav;
        const row = this.pages.goods.rows.find(item => item.id === goods.id);
        if (row) row.liked = goods.fav;
      } catch (error) {
        this.showError(error);
      } finally {
        goods.liking = false;
      }
    },
    // 环境检测：与 veteran.vue 保持一致
    detectMobileOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) return "Windows Phone";
      if (/MicroMessenger/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
        return "WeChatMiniProgram";
      }
      if (/android/i.test(userAgent)) return "Android";
      if (/iPad|iPhone|iPod/.test(userAgent)) return "IOS";
      return "Unknown";
    },
    // App/小程序端获取用户信息（含 token），原生回调 window.setUserInfo
    requestUserInfo() {
      const os = this.detectMobileOS();
      if (os === "IOS") {
        if (window.webkit && window.webkit.messageHandlers) {
          try {
            window.webkit.messageHandlers["getUserInfo"].postMessage(
              "H5获取用户信息"
            );
          } catch (error) {
            console.error("请求失败:", error);
          }
        }
      } else if (os === "WeChatMiniProgram") {
        // 小程序端已在 onLoad 判断登录态并拼 token，此处仅作兜底
        if (window.wx && window.wx.miniProgram) {
          window.wx.miniProgram.postMessage({
            data: { action: "getUserInfo" }
          });
        }
      } else if (os === "Android") {
        if (typeof Android !== "undefined" && Android.getUserInfo) {
          Android.getUserInfo("来自 JavaScript 的消息");
        }
      }
    },
    // 返回：明细视图先回主视图；主视图按环境走原生桥

    // 每日签到
    async doSign() {
      if (!this.requireLogin() || this.signed !== false || this.signing) return;
      this.signing = true;
      try {
        const data = await pointsRequest("sign-in");
        this.signed = true;
        this.balance = data.availablePoints;
        this.$message({
          message: "签到成功，积分+" + data.awardPoints,
          type: "success"
        });
        this.pages.in.more = this.pages.out.more = true;
        await this.loadAll();
      } catch (error) {
        this.showError(error);
      } finally {
        this.signing = false;
      }
    },
    // 去完成：判断来源（小程序/Android/iOS）跳转对应首页
    onTask(task) {
      if (task.ruleCode == "SIGN_IN") return this.doSign();
      const os = this.detectMobileOS();
      if (os === "IOS") {
        if (task.ruleCode == "RESUME") {
          const handler =
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.completeResume;
          if (!handler) {
            this.$message({
              message: "当前 App 暂不支持完善简历跳转，请更新 App",
              type: "warning"
            });
            return;
          }
          try {
            handler.postMessage({ source: "points", taskType: 3 });
          } catch (error) {
            this.showError(error);
          }
          return;
        } else {
          window.webkit.messageHandlers["returnToHomeJob"].postMessage(
            "H5回调"
          );
        }
      }
      if (os === "WeChatMiniProgram") {
        if (task.ruleCode == "RESUME") {
          if (window.wx && window.wx.miniProgram) {
            // resume 是小程序普通页面（不在 tabBar 中），必须用 navigateTo；
            // switchTab 仅对 tabBar 页面生效且失败时静默无回调
            window.wx.miniProgram.navigateTo({
              url: "/pages/resume/resume"
            });
          }
          return;
        } else {
          if (window.wx && window.wx.miniProgram) {
            // indexList（找工作）是 tabBar 页面，只能用 switchTab；
            // 用 navigateTo 打 tabBar 页会静默失败，表现为“点击无反应”
            window.wx.miniProgram.switchTab({
              url: "/pages/indexList/indexList"
            });
          }
        }
      }
      if (os === "Android") {
        if (task.ruleCode == "RESUME") {
          if (typeof Android !== "undefined" && Android.completeResume) {
            Android.completeResume("来自 JavaScript 的消息");
            return;
          }
        } else {
          Android.returnToHomeJob("来自 JavaScript 的消息");
        }
      }
    },
    async openExchange(goods) {
      if (this.exchanging || this.balanceWarnShowing || this.receiverLoading)
        return;
      // 小程序端仅支持积分与商品查看：点兑换时引导下载 App，不走兑换流程
      if (this.detectMobileOS() === "WeChatMiniProgram") {
        // this.showAppTip = true;
        window.wx.miniProgram.navigateTo({
          url: "/pages/downPage/downPage"
        });
        return;
      }
      if (!this.requireLogin()) return;
      if (this.balance !== null && this.balance < goods.points) {
        this.balanceWarnShowing = true;
        this.$message({
          message: "您当前的积分尚未达到兑换要求，抓紧获取更多积分！",
          type: "warning",
          onClose: () => {
            this.balanceWarnShowing = false;
          }
        });
        return;
      }
      this.exchangeProduct = goods;
      this.exchangeForm = { name: "", phone: "", address: "" };
      this.showExchange = true;
      if (goods.goodsType !== 2) return;
      this.receiverLoading = true;
      try {
        const data = await pointsRequest("receiver-info");
        if (data) {
          this.exchangeForm = {
            name: data.receiverName || "",
            phone: data.receiverPhone || "",
            address: data.receiverAddress || ""
          };
        } else {
          // 接口无收货信息（返回 null）时回退取用户信息（bodyguard/center → baBodyguardsInfoVO）的姓名/电话
          const guard =
            (this.userInfo && this.userInfo.baBodyguardsInfoVO) || {};
          this.exchangeForm = {
            name: guard.name || "",
            phone: guard.phone || "",
            address: ""
          };
        }
      } catch (error) {
        this.showError(error);
      } finally {
        this.receiverLoading = false;
      }
    },
    // 确认兑换
    async submitExchange() {
      if (
        this.exchanging ||
        this.receiverLoading ||
        !this.exchangeProduct ||
        !this.requireLogin()
      )
        return;
      const physical = this.exchangeProduct.goodsType === 2;
      const name = this.exchangeForm.name.trim();
      const phone = this.exchangeForm.phone.trim();
      const address = this.exchangeForm.address.trim();
      if (physical && (!name || name.length > 50)) {
        return this.$message({ message: "请输入收货人姓名", type: "warning" });
      }
      if (physical && !/^1\d{10}$/.test(phone)) {
        return this.$message({
          message: "请输入正确的手机号码",
          type: "warning"
        });
      }
      if (physical && (!address || address.length > 100)) {
        return this.$message({ message: "请输入收货人地址", type: "warning" });
      }
      this.exchanging = true;
      try {
        const params = { goodsId: this.exchangeProduct.id };
        if (physical)
          Object.assign(params, {
            receiverName: name,
            receiverPhone: phone,
            receiverAddress: address
          });
        const data = await pointsRequest("exchange", params);
        this.balance = data.availablePoints;
        this.showExchange = false;
        this.$message({
          message: `兑换成功，您已成功消耗${data.pointsCost}积分兑换了${data.goodsName}商品，请注意查收商品！`,
          type: "success"
        });
        await Promise.all([
          this.loadPage("record", true),
          this.loadPage("in", true),
          this.loadPage("out", true)
        ]);
      } catch (error) {
        this.showError(error);
      } finally {
        this.exchanging = false;
      }
    }
  }
};
</script>

<style scoped>
.list-state {
  padding: 5vw;
  text-align: center;
  color: #8d8d8d;
  font-size: 3.5vw;
}
/* 无数据/加载/失败时：提示居中于屏幕正中间 */
.list-state.empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
}
.points-page {
  width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
  background: #f5f6fa;
  font-family: -apple-system, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.points-page--subview {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  min-height: 0;
  overflow: hidden;
}

/* 顶部渐变+金币背景区（pointsBg 含渐变与右侧金币） */
.head {
  position: relative;
  padding-top: 4vw;
  padding-bottom: 10vw;
  background: url("https://baoanlailou-online.oss-cn-beijing.aliyuncs.com/miniapp/pointsBg.png")
      top center / 100% auto no-repeat,
    linear-gradient(120deg, #f6d9d2 0%, #fbeedd 100%);
}

/* 导航栏 */
.points-nav {
  position: relative;
  display: flex;
  align-items: center;
  height: 12vw;
  padding: 0 4vw;
}
.nav-back {
  width: 6vw;
  height: 6vw;
}
.nav-back svg {
  width: 100%;
  height: 100%;
}
.nav-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 4.5vw;
  font-weight: 600;
  color: #333;
}
.points-nav.plain {
  background: #fff;
}

/* 积分余额区（压在头部背景上，无卡片） */
.balance-wrap {
  position: relative;
  padding: 2vw 4vw 0;
}
.balance-row {
  display: flex;
  align-items: center;
}
.balance-icon {
  width: 5.6vw;
  height: 5.6vw;
}
.balance-label {
  margin-left: 1.6vw;
  font-size: 3.7vw;
  color: #333;
}
.balance-rules {
  margin-left: auto;
  font-size: 3.7vw;
  color: #333;
}
.balance-num {
  margin-top: 1.6vw;
  font-size: 8.5vw;
  font-weight: 700;
  color: #2b2b2b;
}
.balance-detail {
  margin-top: 1.6vw;
  font-size: 3.4vw;
  color: #8d8d8d;
}
.sign-btn {
  position: absolute;
  top: 11vw;
  right: 4vw;
  display: flex;
  align-items: center;
  padding: 2.6vw 6vw;
  border-radius: 1.6vw;
  background: linear-gradient(90deg, #f89b3d, #ee7517);
  color: #fff;
  font-size: 4vw;
  font-weight: 600;
}
.sign-btn .sign-icon {
  width: 4.8vw;
  height: 4.8vw;
  margin-right: 2vw;
}
.sign-btn.signed {
  background: #f3c99d;
  color: #8d5a2b;
}

/* 做任务领积分：顶部奶油渐变条 + 上移压住头部金币 */
.task-card {
  position: relative;
  margin: -6vw 3vw 0;
  padding: 4vw 4vw 1vw;
  border-radius: 4.2vw;
  background: url("https://baoanlailou-online.oss-cn-beijing.aliyuncs.com/miniapp/pointsTopBg.png")
      top center / 100% auto no-repeat,
    #fff;
}
.task-title {
  position: relative;
  display: inline-block;
  font-size: 4vw;
  font-weight: 700;
  color: #333;
}
/* 标题下划条装饰图（static 渐变条，右对齐到标题尾部） */
.title-bar {
  position: absolute;
  right: 0;
  bottom: -1.2vw;
  height: auto;
}
.task-title .title-bar {
  width: 13vw;
}
.task-row {
  display: flex;
  align-items: center;
  padding: 3.4vw 0;
}
.task-icon {
  flex: 0 0 9.6vw;
  width: 9.6vw;
  height: 9.6vw;
}
.task-info {
  flex: 1;
  margin-left: 3vw;
}
.task-name {
  font-size: 3.5vw;
  font-weight: 500;
  color: #333;
}
.task-points {
  margin-top: 1.2vw;
  font-size: 4vw;
  font-weight: 700;
  color: #f0483e;
}
.task-note {
  margin-left: 2vw;
  font-size: 3.4vw;
  font-weight: 400;
  color: #999;
}
.task-pill {
  padding: 1.6vw 4vw;
  border-radius: 999px;
  font-size: 3.7vw;
}
.task-pill.done {
  background: #d9f3e5;
  color: #35c48b;
}
.task-go {
  padding: 1.6vw 4vw;
  border-radius: 999px;
  background: linear-gradient(90deg, #f89b3d, #ee7517);
  color: #fff;
  font-size: 3.7vw;
}

/* 积分商品兑换 */
.goods-section {
  padding: 5vw 3vw 8vw;
}
.goods-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.goods-title {
  position: relative;
  display: inline-block;
  font-size: 4.5vw;
  font-weight: 700;
  color: #333;
}
.goods-title .title-bar {
  width: 9vw;
}
.goods-record {
  font-size: 3.4vw;
  color: #8d8d8d;
}
.goods-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 3.5vw;
}
.goods-card {
  width: 48.5%;
  margin-bottom: 3.5vw;
  padding: 0 0 3vw;
  border-radius: 2.5vw;
  background: #fff;
  overflow: hidden;
}
.goods-img {
  width: 100%;
  height: 45vw;
  background: #f0f1f5;
}
.goods-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.goods-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.6vw 3vw 0;
}
.goods-name {
  font-size: 3.7vw;
  color: #333;
  flex: 1;
  min-width: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  height: calc(3.7vw * 1.4 * 2);
}
.goods-fav {
  width: 4.8vw;
  height: 4.8vw;
  flex-shrink: 0;
  margin-left: 2vw;
}
.goods-fav svg {
  width: 100%;
  height: 100%;
}
.goods-buy-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.2vw 3vw 0;
}
.goods-points {
  font-size: 4vw;
  font-weight: 700;
  color: #ff7519;
}
.goods-exchange {
  flex: none;
  padding: 1.6vw 4.2vw;
  border-radius: 999px;
  background: linear-gradient(90deg, #ffa751, #ff7519);
  color: #fff;
  font-size: 3.5vw;
  font-weight: 600;
}

/* 积分明细 */
.detail-view {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: #f5f6fa;
}
/* 中间列表仅在此区域内部滚动：顶部 tabs 与底部返回按钮始终可见 */
.detail-list {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
}
/* 返回区参与布局并预留安全区，不再覆盖列表尾部内容。 */
.detail-footer {
  flex-shrink: 0;
  padding: 3vw 4vw 4vw;
  padding-bottom: calc(4vw + constant(safe-area-inset-bottom));
  padding-bottom: calc(4vw + env(safe-area-inset-bottom));
  background: #f5f6fa;
}
/* 明细/兑换记录底部返回按钮 */
.detail-back {
  padding: 3.6vw 0;
  border-radius: 2.4vw;
  background: #eceef2;
  text-align: center;
  font-size: 4.2vw;
  color: #333;
}
.detail-tabs {
  display: flex;
  flex-shrink: 0;
  background: #fff;
}
.detail-tab {
  flex: 1;
  position: relative;
  padding: 3.6vw 0;
  text-align: center;
  font-size: 3.7vw;
  color: #666;
}
.detail-tab.active {
  color: #2f6bff;
  font-weight: 600;
}
.detail-tab.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 8vw;
  height: 0.8vw;
  border-radius: 999px;
  background: #2f6bff;
}
.detail-month {
  padding: 3vw 4vw;
  font-size: 3.2vw;
  color: #999;
}
.detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 4vw 3vw;
  padding: 3.6vw 4vw;
  border-radius: 2.5vw;
  background: #fff;
}
.detail-label {
  font-size: 4vw;
  font-weight: 600;
  color: #333;
}
.detail-time {
  margin-top: 1.6vw;
  font-size: 3.2vw;
  color: #999;
}
.detail-amount {
  font-size: 4.3vw;
  font-weight: 700;
  color: #333;
}
.detail-amount.plus {
  color: #f23850;
}

/* 弹窗公共 */
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
}
.box-close {
  position: absolute;
  top: 4vw;
  right: 4vw;
  width: 5vw;
  height: 5vw;
}
.box-close svg {
  width: 100%;
  height: 100%;
}

/* 积分兑换规则弹窗：绝对定位锚定屏幕正中心 */
.rules-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 76vw;
  padding: 10vw 6vw 6vw;
  border-radius: 3vw;
  background: linear-gradient(180deg, #dce8ff 0%, #fff 35%);
}
.rules-bell {
  position: absolute;
  top: -8vw;
  left: 50%;
  transform: translateX(-50%);
  width: 16vw;
  height: 16vw;
  border-radius: 50%;
  background: linear-gradient(180deg, #4d9bff, #2f6bff);
  display: flex;
  align-items: center;
  justify-content: center;
}
.rules-bell svg {
  width: 8vw;
  height: 8vw;
}
.rules-title {
  text-align: center;
  font-size: 4.3vw;
  font-weight: 700;
  color: #333;
}
.rules-body {
  margin-top: 4vw;
}
.rules-body p {
  margin: 0 0 3vw;
  font-size: 3.5vw;
  line-height: 1.7;
  color: #333;
}

/* 商品兑换弹窗：同样锚定屏幕正中心 */
.exchange-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 82vw;
  padding: 5vw 5vw 6vw;
  border-radius: 3vw;
  background: linear-gradient(180deg, #e8f3ff 0%, #fff 30%);
}
.exchange-head {
  display: flex;
  align-items: center;
}
.exchange-title {
  font-size: 4.3vw;
  font-weight: 700;
  color: #333;
}
.exchange-sub {
  margin-top: 2vw;
  font-size: 3.2vw;
  color: #666;
}
.form-item {
  margin-top: 4vw;
}
.form-label {
  font-size: 3.7vw;
  color: #333;
}
.form-item input {
  width: 100%;
  margin-top: 1.6vw;
  padding: 2.4vw 0;
  border: none;
  border-bottom: 1px solid #e6e6e6;
  outline: none;
  background: transparent;
  font-size: 3.5vw;
  color: #333;
}
.form-item input::placeholder {
  color: #b9bfc9;
}
.exchange-submit {
  margin-top: 7vw;
  padding: 3.2vw 0;
  border-radius: 2vw;
  background: #2f6bff;
  text-align: center;
  color: #fff;
  font-size: 4vw;
  font-weight: 600;
}

/* 小程序兑换引导下载 App 弹窗 */
.app-tip-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 72vw;
  padding: 5vw 5vw 6vw;
  border-radius: 4vw;
  text-align: center;
}
.app-tip-img {
  display: block;
  width: 100%;
  height: auto;
}
.app-tip-text {
  margin: 2.4vw 0 0;
  font-size: 3.9vw;
  line-height: 1.5;
  color: #333;
}
.app-tip-btn {
  margin-top: 6vw;
  padding: 4vw 0;
  border-radius: 999px;
  background: linear-gradient(90deg, #55a4ff, #2f6bff);
  color: #fff;
  font-size: 4.3vw;
  font-weight: 600;
}
.app-tip-close {
  position: absolute;
  left: 50%;
  bottom: -14vw;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10vw;
  height: 10vw;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
}
.app-tip-close svg {
  width: 5vw;
  height: 5vw;
}
</style>



// WEBPACK FOOTER //
// src/view/points/points.vue